import React from 'react'

import { IconComponent } from '@application/Interfaces/Icons/types'

export const MagnifyingGlassIcon: IconComponent = ({ className, width = 98, height = 98 }) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 98 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M38.2783 55.5317L44.5518 61.8053L36.1873 70.1698L29.9138 63.8962L38.2783 55.5317Z"
                    fill="#F99727"
                />
                <path
                    d="M36.187 53.4406L40.3694 57.6229L32.0049 65.9874L27.8225 61.8051L36.187 53.4406Z"
                    fill="#FFC889"
                />
                <path
                    d="M38.2761 68.0897L34.0932 63.9069L25.7275 68.0897L34.0932 72.2726C35.2483 73.4277 37.121 73.4277 38.2761 72.2726C39.4312 71.1177 39.4312 69.2448 38.2761 68.0897Z"
                    fill="#FFC889"
                />
                <path
                    d="M34.0933 68.0898C35.2484 66.9347 35.2484 65.0621 34.0933 63.907L29.9105 59.7241C28.7554 58.569 26.8828 58.569 25.7277 59.7241C24.5726 60.8792 24.5726 62.7519 25.7277 63.907V68.0898H29.9105C31.0656 69.2449 32.9382 69.2449 34.0933 68.0898Z"
                    fill="#FFE0BC"
                />
                <path
                    d="M46.6421 59.7239L42.4592 55.541L38.2764 59.7239L42.4592 63.9067C43.6143 65.0618 45.487 65.0618 46.6421 63.9067C47.797 62.7516 47.797 60.879 46.6421 59.7239Z"
                    fill="#FFC889"
                />
                <path
                    d="M42.4591 59.7239C43.6142 58.5689 43.6142 56.6962 42.4591 55.5411L38.2762 51.3583C37.1211 50.2032 35.2485 50.2032 34.0934 51.3583C32.9383 52.5134 32.9383 54.386 34.0934 55.5411L38.2762 59.7239C39.4313 60.879 41.3042 60.879 42.4591 59.7239Z"
                    fill="#FFE0BC"
                />
                <path
                    d="M34.0934 72.2726L29.9106 68.0897L2.59912 95.4012C6.06442 98.8665 11.6826 98.8665 15.1479 95.4012L34.0934 76.4556C35.2485 75.3005 35.2485 73.4277 34.0934 72.2726Z"
                    fill="#0B5D97"
                />
                <path
                    d="M10.9649 91.2183L29.9104 72.2728C31.0655 71.1177 31.0655 69.245 29.9104 68.0899L25.7276 63.9071C24.5725 62.752 22.6998 62.752 21.5447 63.9071L2.59897 82.8524C-0.866324 86.3177 -0.866324 91.9359 2.59897 95.4012C3.75407 96.5563 7.49956 94.6834 10.9649 91.2183Z"
                    fill="#146FB7"
                />
                <path
                    d="M65.4649 65.0704C83.4336 65.0704 98.0001 50.5039 98.0001 32.5352C98.0001 14.5665 83.4336 0 65.4649 0C47.4962 0 32.9297 14.5665 32.9297 32.5352C32.9297 50.5039 47.4962 65.0704 65.4649 65.0704Z"
                    fill="#F99727"
                />
                <path
                    d="M65.4648 5.91541V59.1548C80.1664 59.1548 92.0845 47.2367 92.0845 32.5351C92.0845 17.8335 80.1664 5.91541 65.4648 5.91541Z"
                    fill="#E5F2FF"
                />
                <path
                    d="M86.1691 32.5351C86.1691 17.8335 76.8996 5.91541 65.4649 5.91541C50.7634 5.91541 38.8452 17.8335 38.8452 32.5351C38.8452 47.2367 50.7634 59.1548 65.4649 59.1548C76.8996 59.1548 86.1691 47.2367 86.1691 32.5351Z"
                    fill="white"
                />
                <path
                    d="M77.2961 35.493C78.9296 35.493 80.2539 34.1688 80.2539 32.5353C80.2539 30.9017 78.9296 29.5775 77.2961 29.5775C75.6626 29.5775 74.3384 30.9017 74.3384 32.5353C74.3384 34.1688 75.6626 35.493 77.2961 35.493Z"
                    fill="#146FB7"
                />
                <path
                    d="M65.4651 35.493C67.0986 35.493 68.4228 34.1688 68.4228 32.5353C68.4228 30.9017 67.0986 29.5775 65.4651 29.5775C63.8316 29.5775 62.5073 30.9017 62.5073 32.5353C62.5073 34.1688 63.8316 35.493 65.4651 35.493Z"
                    fill="#146FB7"
                />
                <path
                    d="M53.634 35.493C55.2675 35.493 56.5918 34.1688 56.5918 32.5353C56.5918 30.9017 55.2675 29.5775 53.634 29.5775C52.0005 29.5775 50.6763 30.9017 50.6763 32.5353C50.6763 34.1688 52.0005 35.493 53.634 35.493Z"
                    fill="#146FB7"
                />
            </g>
        </svg>
    )
}
